import React from "react";
import dataLoading from "../../assets/images/BN_Rathi_Loading.gif";

const CommonLoading = ({ alt = "loading", className = "", style = {} }) => {
  return (
    <img
      src={dataLoading}
      alt={alt}
      className={`loading-responsive ${className}`}
      style={style}
    />
  );
};

export default CommonLoading;
